import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["extraFields", "textInputWrapper"]

  toggleExtra(event) {
    if (event.target.checked) {
      this.extraFieldsTarget.classList.remove("hidden")
    } else {
      this.extraFieldsTarget.classList.add("hidden")
    }
  }

  toggleInnerCheckbox(event) {
    if (event.target.checked) {
      this.textInputWrapperTarget.classList.add("hidden")
    } else {
      this.textInputWrapperTarget.classList.remove("hidden")
    }
  }

  textTyped(event) {
    if (event.target.value.length > 0) {
      this.textInputWrapperTarget.classList.remove("hidden")
    }
  }
}
